import type { IActionGameConfig } from '@nova/types';

import { mergeModeGameConfig } from '../../config-utils';

import zoneRushModeConfigJson from './zone-rush-mode.config.json';

/** Builds the merged zone-rush AGE game config from the shared action-game base. */
export function loadZoneRushGameConfig(base: IActionGameConfig): IActionGameConfig {
  return mergeModeGameConfig<IActionGameConfig>(base, zoneRushModeConfigJson);
}
